import type { DevToolsPlugin } from './types';

export class PluginRegistry {
  private plugins: Map<string, DevToolsPlugin> = new Map();
  private listeners: Array<() => void> = [];

  register(plugin: DevToolsPlugin): void {
    this.plugins.set(plugin.id, plugin);
    this.listeners.forEach((cb) => cb());
  }

  unregister(id: string): void {
    this.plugins.delete(id);
    this.listeners.forEach((cb) => cb());
  }

  getAll(): DevToolsPlugin[] {
    return Array.from(this.plugins.values());
  }

  onChange(callback: () => void): () => void {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== callback);
    };
  }

  notifyBadgeChange(id: string): void {
    window.dispatchEvent(new CustomEvent('acme:devtools-badge-update', { detail: { id } }));
  }
}

export const pluginRegistry = new PluginRegistry();
